import { CmpProspectFieldsFragment } from "../../../graphql/types";

const RECENT_WINDOW_MILLI = 60_000;
type RecentProspect = {
  prospect: CmpProspectFieldsFragment;
  createdAt: number;
};
const recentProspects = new Map<string, RecentProspect>();

export const recordRecentlyCreatedProspect = ({
  prospect,
}: {
  prospect: CmpProspectFieldsFragment;
}): void => {
  recentProspects.set(`${prospect.chamberId}:${prospect.id}`, {
    prospect,
    createdAt: Date.now(),
  });
};

export const getRecentlyCreatedProspects = (
  chamberId: string,
): CmpProspectFieldsFragment[] => {
  const now = Date.now();
  recentProspects.forEach((entry, key) => {
    if (now - entry.createdAt >= RECENT_WINDOW_MILLI)
      recentProspects.delete(key);
  });
  return Array.from(recentProspects.values())
    .filter((entry) => entry.prospect.chamberId === chamberId)
    .sort((first, second) => second.createdAt - first.createdAt)
    .map((entry) => entry.prospect);
};

export const acknowledgeRecentlyCreatedProspect = (
  chamberId: string,
  prospectId: string,
): void => {
  recentProspects.delete(`${chamberId}:${prospectId}`);
};
